"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiStore = void 0;
const mobx_1 = require("mobx");
const check_is_mobile_1 = require("@App/helpers/check-is-mobile");
const url_1 = require("@App/helpers/url");
class UiStore {
    constructor(rootStore) {
        Object.defineProperty(this, "_rootStore", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_windowSize", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_onLoginPage", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        Object.defineProperty(this, "_homePageState", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        // todo move this bulk upload wizard store when it is made
        Object.defineProperty(this, "_bulkUploadModalIsOpen", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        (0, mobx_1.makeObservable)(this, {
            _windowSize: mobx_1.observable,
            _onLoginPage: mobx_1.observable,
            _homePageState: mobx_1.observable,
            _bulkUploadModalIsOpen: mobx_1.observable,
            setWindowSize: mobx_1.action,
            setOnLoginPage: mobx_1.action,
            setHomePageState: mobx_1.action,
            setBulkUploadModalIsOpen: mobx_1.action,
            isMobile: mobx_1.computed,
            homePageState: mobx_1.computed,
            currentTheme: mobx_1.computed,
        });
        this._rootStore = rootStore;
        this._bulkUploadModalIsOpen = true;
        this._onLoginPage = (0, url_1.urlHasComponent)('login');
    }
    get windowSize() {
        return this._windowSize;
    }
    get onLoginPage() {
        return this._onLoginPage;
    }
    get bulkUploadModalIsOpen() {
        return this._bulkUploadModalIsOpen;
    }
    get homePageState() {
        var _a, _b, _c, _d;
        const hasBoth = ((_a = this._rootStore.songwriterSearchStore.songwriters) === null || _a === void 0 ? void 0 : _a.totalElements) > 0 &&
            ((_b = this._rootStore.rightsholderSearchStore.rightsholders) === null || _b === void 0 ? void 0 : _b.totalElements) > 0;
        return ((_c = this._homePageState) !== null && _c !== void 0 ? _c : (hasBoth
            ? 'member'
            : ((_d = this._rootStore.songwriterSearchStore.songwriters) === null || _d === void 0 ? void 0 : _d.totalElements) > 0
                ? 'songwriter'
                : 'member'));
    }
    get currentTheme() {
        return this._rootStore.songwriterStore.optionalCurrentSongwriterId || this.homePageState === 'songwriter'
            ? 'songwriter-standard'
            : 'member-standard';
    }
    setWindowSize(widthData) {
        this._windowSize = widthData;
    }
    setOnLoginPage(onLogin) {
        this._onLoginPage = onLogin;
    }
    setBulkUploadModalIsOpen(isOpen) {
        this._bulkUploadModalIsOpen = isOpen;
    }
    setHomePageState(state) {
        this._homePageState = state;
    }
    get isMobile() {
        return this._windowSize && (0, check_is_mobile_1.checkIsMobile)(this._windowSize && this._windowSize.width);
    }
}
exports.UiStore = UiStore;
